import Headroom from "headroom.js";

export default () => ({
  scope: {
    tolerance: "=",
    offset: "=",
    classes: "=",
    scroller: "@",
  },
  link($scope, $element) {
    const options = {};
    const opts = Headroom.options;
    for (var prop in opts) {
      options[prop] = $scope[prop] || opts[prop];
    }
    if ($scope.scroller) {
      options.scroller = document.querySelector($scope.scroller);
    }
    const headroom = new Headroom($element[0], options).init();
    $scope.$on("$destroy", function () {
      headroom.destroy();
    });
  },
});
